<template>
  <div class="wait-view-container">
    <div v-if="gameState.roundIndex < 0">
      <WaitViewAnimation />
      <div class="info-container">
        <div class="wait-message">
          {{ statusMessage }}
        </div>
        <div class="game-roomcode-item">
          <transition name="pop-from-top">
            <div v-show="displayCopiedMessage" class="copied-message-item">
              Copied room code!
            </div>
          </transition>
          Room Code: {{ gameRoomcode }}
          <span
            v-if="isClipboardAPIAvailable"
            @click="copyRoomcodeToClipboard"
            class="copy-button"
          >
            <font-awesome-icon :icon="['fas', 'copy']" />
          </span>
        </div>
        <transition name="pop-from-top">
          <SpinnerButton
            v-show="canStartGame"
            class="start-game-button"
            :isProcessing="startGameButtonClicked"
            @click="startGame"
          >
            Start Game
          </SpinnerButton>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import WaitViewAnimation from '@/components/gameComponents/WaitViewAnimation.vue';
import SpinnerButton from '@/components/utilComponents/SpinnerButton.vue';

export default Vue.extend({
  name: 'DemoWaitView',
  components: {
    WaitViewAnimation,
    SpinnerButton
  },
  props: {
    gameRoomcode: String,
    gameState: Object,
    isHost: Boolean
  },
  data: () => ({
    isClipboardAPIAvailable: false,
    displayCopiedMessage: false,
    startGameButtonClicked: false,
  }),
  computed: {
    statusMessage: function () {
       if ('gameStatus' in this.gameState) {
          if (this.gameState.gameStatus === 'waitingForPlayers') {
            return 'Waiting for at least three players to join';
          } else if (this.gameState.gameStatus === 'waitingToStart') {
            if (this.isHost) {
              return 'Waiting for you to start the game';
            }
            return 'Waiting for the host to start the game';
          }
       }
       return '';
    },
    canStartGame: function () {
      return this.isHost && this.gameState.gameStatus === 'waitingToStart';
    }
  },
  methods: {
    async copyRoomcodeToClipboard() {
      await navigator.clipboard.writeText(this.gameRoomcode);
      this.displayCopiedMessage = true;
      await setTimeout(() => {
        this.displayCopiedMessage = false;
      }, 2000);
    },
    startGame() {
      this.startGameButtonClicked = true;
      setTimeout(() => this.$emit('update-game-state', 'gameStart'), 500); // add a little delay to make it seem authentic
    },
  },
  created: async function() {
    this.isClipboardAPIAvailable = !!navigator.clipboard;
  }
})
</script>

<style scoped lang="scss">
@import '@/styles/wait-view-styles.scss';
</style>
